import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import {getPrograms} from "@/store/program-summary/action";

export const createProgram = createAsyncThunk('programDetail/createProgram',
  async (data: any, { dispatch }) => {
    const response: AxiosResponse = await instance.post('v1/programs', data)
    dispatch(getPrograms({}))
    return response.data
  })

export const editProgram = createAsyncThunk('programDetail/editProgram',
  async (data: any, { dispatch }) => {
    const response: AxiosResponse = await instance.put(`v1/programs/${data.id}`, data)
    dispatch(getPrograms({}))
    return response.data
  })

export const getProgramDetail = createAsyncThunk('programDetail/getProgramDetail',
  async (id: string) => {
    const response: AxiosResponse<Program> = await instance.get(`v1/programs/${id}`)
    return response.data
  })